import { Layout } from "@/components/Layout";
import { Award, Users, MapPin, TrendingUp } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function About() {
  return (
    <Layout>
      <div className="border-b border-slate-200 bg-[#E3ECFB] py-16">
        <div className="container-x max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Our Story</p>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-slate-900 lg:text-5xl">About F&amp;L Cars</h1>
          <p className="mt-4 text-lg text-slate-600">Premium Vehicles. Flexible Financing. We make luxury automotive ownership accessible through transparent, customer-first financing.</p>
        </div>
      </div>
      <div className="container-x py-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
          <img src={IMG} alt="F&L Cars showroom" className="rounded-2xl border border-slate-200 object-cover" />
          <div>
            <h2 className="font-display text-3xl font-bold text-slate-900">Driven by Trust</h2>
            <p className="mt-4 leading-relaxed text-slate-600">F&amp;L Cars was founded on a simple belief: financing a premium vehicle should be as refined as the vehicle itself. We combine a hand-selected inventory of America's most sought-after models with flexible, transparent in-house financing.</p>
            <p className="mt-4 leading-relaxed text-slate-600">Every step — from estimating your monthly payment to tracking your contract — is designed to be clear, secure, and effortless. No hidden fees, no surprises, just premium service.</p>
          </div>
        </div>
        <div className="mt-16 grid grid-cols-2 gap-6 lg:grid-cols-4">
          {[[Award, "Premium", "Curated Inventory"], [Users, "Customer-First", "Dedicated Support"], [MapPin, "Nationwide", "US Coverage"], [TrendingUp, "Transparent", "No Hidden Fees"]].map(([Icon, t, d]) => (
            <div key={t} className="card-surface p-6 text-center">
              <Icon className="mx-auto h-8 w-8 text-gold" />
              <div className="mt-3 font-display text-lg font-bold text-slate-900">{t}</div>
              <div className="text-xs text-slate-600">{d}</div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
